module.exports = __webpack_public_path__ + "static/media/weixiujigong1.692ca19e.png";